import React, { useEffect } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";

function Footer() {

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div>
      <footer
        id="colophon"
        className="site-footer footer-primary"
        style={{ backgroundImage: "url(assets/images/img13.jpg)" }}
      >
        <div className="overlay" />
        <div className="container">
          <div className="top-footer">
            <div className="row">
              <div className="col-lg-4 col-md-6">
                <aside className="widget widget_text">
                  <div className="footer-logo ">
                    <a href="/">
                      <img src="assets/images/Codenix.png" alt="Logo" width={160} height={90} />
                    </a>
                  </div>
                  <div className="textwidget widget-text">
                    Empowering businesses with AI automation, innovation, and
                    digital transformation for sustainable growth..
                  </div>

                  <div className="social-links">
                    <ul>
                      <li>
                        <a href="https://www.facebook.com/profile.php?id=61585240401460" target="_blank">
                          <i className="fab fa-facebook-f" aria-hidden="true" />
                        </a>
                      </li>
                      <li>
                        <a href="https://x.com/Codenixinfotech/" target="_blank">
                          <i className="fab fa-x-twitter" aria-hidden="true" />
                        </a>
                      </li>
                      {/* <li>
                  <a href="https://www.youtube.com/" target="_blank">
                    <i className="fab fa-youtube" aria-hidden="true" />
                  </a>
                </li> */}
                      <li>
                        <a href="https://www.instagram.com/codenix_infotech/" target="_blank">
                          <i className="fab fa-instagram" aria-hidden="true" />
                        </a>
                      </li>
                      <li>
                        <a href="https://www.linkedin.com/company/codenix-infotech-private-limited/" target="_blank">
                          <i className="fab fa-linkedin" aria-hidden="true" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </aside>
              </div>
              <div className="col-lg-2 col-md-6" data-aos="fade-up" >
                <aside className="widget">
                  <h3 className="widget-title " style={{ marginBottom: "#fff" }}>Quick Links</h3>
                  <ul>
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li>
                      <a href="/about">About  Us</a>
                    </li>
                    {/* <li>
                <a href="/career">Careers</a>
              </li> 
              <li>
                <a href="/blog">News &amp; Articles</a>
              </li>
              <li>
                <a href="/">Legal Notice</a>
              </li>*/}

                    <li>
                      <a href="/services">services</a>
                    </li>
                  </ul>
                </aside>
              </div>
              <div className="col-lg-2 col-md-6" data-aos="fade-up">
                <aside className="widget">
                  <h3 className="widget-title">Other Pages</h3>
                  <ul>
                    {/* <li>
                <a href="/contact">Help Center</a>
              </li>*/}
                    <li>
                      <a href="/contact">Contact Us</a>
                    </li>
                    <li>
                      <a href="/Faq">FAQ</a>
                    </li>
                    <li>
                      <a href="/career">Careers</a>
                    </li>
                    {/* <li>
                <a href="team.html">Parent Community</a>
              </li>
              <li>
                <a href="/portfolio">Projects</a>
              </li> */}
                  </ul>
                </aside>
              </div>
              <div className="col-lg-4 col-md-6 " data-aos="fade-up">
                <aside className="widget contact-widget">
                  <h3 className="widget-title">Location Address</h3>
                  <p style={{ color: "#fff" }}>Know where to find us? Let's take a look and get in touch !</p>
                  <div className="widget-wrap row">
                    <div className="widget-map col-sm-6">
                      <img src="assets/images/map-widget.png" alt="" />
                      <div className="hotspot">
                        <div className="hotspot-one">
                          <a href="#">
                            <i className="fas fa-map-marker-alt" />
                          </a>
                          <span className="hotspot-content"></span>
                        </div>
                        <div className="hotspot-two">
                          <a href="#">
                            <i className="fas fa-map-marker-alt" />
                          </a>
                          <span className="hotspot-content"></span>
                        </div>
                        {/* <div className="hotspot-three">
                    <a href="#">
                      <i className="fas fa-map-marker-alt" />
                    </a>
                    <span className="hotspot-content"></span>
                  </div> */}
                        <div className="hotspot-four">
                          <a href="https://www.google.com/maps?q=13.087854,80.256225&z=17">
                            <i className="fas fa-map-marker-alt" />
                          </a>
                          <span className="hotspot-content">Chennai</span>
                        </div>
                        <div className="hotspot-five">
                          <a href="#">
                            <i className="fas fa-map-marker-alt" />
                          </a>
                          <span className="hotspot-content"></span>
                        </div>
                      </div>
                    </div>
                    <div className="contact-detail-widget col-sm-6" data-aos="fade-up">
                      <ul>
                        <li style={{ color: "#fff", fontWeight: "bold" }}>
                          <i aria-hidden="true" className="icon icon-map-marker1" />
                          Chennai
                        </li>
                        <li>
                          <a href="https://wa.me/919629456090">
                            <i aria-hidden="true" className="fa-brands fa-square-whatsapp" />
                            +91 96294 56090
                          </a>
                        </li>
                        <li>
                          <a href="mailto:info@codenixinfotech.com">
                            <i aria-hidden="true" className="icon icon-envelope1" />
                            <span
                              className="__cf_email__"
                              data-cfemail="b8d1d6ded7f8dcd7d5d9d1d696dbd7d5"
                            >
                              Codenix&nbsp;infotech
                            </span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </aside>
              </div>
            </div>
          </div>
          <div className="bottom-footer">
            <div className="row">
              <div className="col-lg-8 offset-lg-4">
                <div className="bottom-footer-content row">
                  <div
                    className="copy-right col-7 fw-semibold"
                    style={{ width: "auto" }}
                  >
                    Copyright © {new Date().getFullYear()}{" "}
                    <span style={{ color: "#D2C1B8", fontWeight: "550" }}>
                      CodenixInfotech Private Limited
                    </span>
                    . All rights reserved.
                  </div>


                  <div className="footer-menu text-right col-5">
                    <ul>
                      {/* <li>
                  <a href="/">Privacy Policy</a>
                </li>
                <li>
                  <a href="/">Term &amp; Condition</a>
                </li> */}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <a id="backTotop" href="#" class="to-top-icon">
        <i class="fas fa-chevron-up"></i>
      </a>
      <div class="header-search-form">
        <div class="container">
          <div class="header-search-container">
            <form class="search-form" role="search" method="get" >
              <input type="text" name="s" placeholder="Enter your text..."></input>
            </form>
            <a href="#" class="search-close">
              <i class="fas fa-times"></i>
            </a>
          </div>
        </div>
      </div>

    </div>
  )
}

export default Footer
